import { useSelector, useDispatch } from 'react-redux'
import { addQtd } from '../../../state/slices/formSlice'
import React from 'react'

const QtdModulo = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const modo = useSelector((state) => state.addForm.modo)
    const dispatch = useDispatch()

    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const principalWidth = mediaWeb ? "50vw" : "90vw"
    const botoesWidth = mediaWeb ? "3vw" : "7vw"
    const inputWidth = mediaWeb ? "4vw" : "8vw"
    const fonte = mediaWeb ? "16px" : "12px"

    const estilo = {
        principal: {
            borderBottom: "1px solid #00000029", width: principalWidth,
            margin: "auto", marginTop: "2vh", marginBottom: "2vh", fontSize: fonte,
            textAlign: "left", color: "#000000", display: "inline-block"
        },
        direita: {
            float: "right", position: "relative", top: "-3px"
        },
        quantidade: {
            marginLeft: "0.5vw", marginRight: "0.5vw", width: inputWidth,
            borderRadius: "5px", backgroundColor: "#00000000", textAlign: "center"
        },
        menos: {
            width: botoesWidth,
            backgroundColor: "#E90303", color: "#FFFF",
            border: "none", borderRadius: "5px"
        },
        mais: {
            width: botoesWidth, marginRight: "0.5vw",
            backgroundColor: "#42A908", color: "#FFFF",
            border: "none", borderRadius: "5px"
        }
    }

    if (modo === "view") return null
    else {
        return (
            <div>
                <div style={estilo.principal}>
                    <div style={{ display: "inline-block" }}>
                        {props.texto}
                    </div>
                    <div style={estilo.direita}>
                        <button style={estilo.menos}
                            name="menos"
                            onClick={e => dispatch(addQtd({ e, modulo }))}>-</button>
                        <input style={estilo.quantidade} value={updatedForm} />
                        <button style={estilo.mais}
                            name="mais"
                            onClick={e => dispatch(addQtd({ e, modulo }))}>+</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default QtdModulo